export const STANDARD_BRANCH_MANAGER = 'standard.branch.manager';
export const SERVICE_PLUGIN_MANAGER = 'service.plugin.manager';
export const UI_PLUGIN_MANAGER = 'global.setting.plugin.manager';
